
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Lavathavati Vikrala Brahmandi Mala" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Lavathavati Vikrala Brahmandi Mala" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shri Shankarachi Aarti, lavthavti vikrala aarti lyrics marathi, lavthavti vikrala aarti lyrics english, lavthavti vikrala aarti, lavthavti vikrala'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Shri Shankarachi Aarti, Marathi Aarti, Lord Shiva Aarti, Shankar Devotional aarti, Aarti lyrics, शंकराची आरती, lavthavti vikrala aarti lyrics marathi, lavthavti vikrala aarti lyrics english,lavthavti vikrala aarti lyrics, लवथवती विक्राळा - Lavthavti Vikrala, Lavthavti Vikrala Aarti, Lord Shiva Aarti, लवथवती विक्राळा'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/shiva.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/shiva.webp'
          },
          ],
        }
      },
    
       components: {
      },
      data() {
        return {
          title: 'Lavathavati Vikrala Brahmandi Mala | Shankarachi Aarti  - लवथवती विक्राळा ब्रह्माण्डी माळा (शंकराची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/shiva"
        },
        "headline": "Lavathavati Vikrala Brahmandi Mala - लवथवती विक्राळा ब्रह्माण्डी माळा (शंकराची आरती)",
        "name" : "Lavathavati Vikrala Brahmandi Mala - Shankarachi Aarti",
        "description": "Explore the full lyrics of Aarti 'Lavathavati Vikrala Brahmandi Mala' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/shiva.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
      changeLanguage:function () {
        this.langauageMarathi = !this.langauageMarathi
      }
    }
  
    }
  